import { render } from "./OrderSummaryList.vue?vue&type=template&id=29f4f6ab"
import script from "./OrderSummaryList.vue?vue&type=script&lang=js"
export * from "./OrderSummaryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__